import Sketcher from "../model/Sketcher";
import Screenshotter from "../model/Screenshotter";
import I18N from "oc-I18N";
import { v3 } from "oc-threejs/short3";
import DeviceDetection from "oc-commons/DeviceDetection";
import InterieurDragBox from "../object3d/InterieurDragBox";
import HeightDragHandle from "../object3d/HeightDragHandle";
import Fach from "../object3d/Fach";
import { Scene } from "three";
import Urls from "oc-commons/Urls";
import Commons from "oc-commons/Commons";


export default class uiActions {

    static _saveAction(onSuccess, onError) {
        uiActions._saveCfg((data) => {
            const afterShoot = () => {
                let link = window.location.href.split('?')[0] + "?Code=" + data.Code;
                const save_to_basket_callback_url = APP.settings.save_to_basket_callback_url.replace("{Code}",data.Code);
                // console.log('calling save_to_basket_callback_url=',save_to_basket_callback_url);
                $.ajax({
                    url: save_to_basket_callback_url,
                    type: 'GET'
                });
                window.history.replaceState('page2', 'Title', link);
                APP.configuration.Code = data.Code;
                onSuccess(link, data);
            };
            uiActions._makeImages(data, afterShoot);
        }, onError);
    }


    static _saveCfg(callback, errorcallback) {
        APP.save(callback, errorcallback);
    }

    static _makeImages(data, callback) {
        let sketcher;
        const screenshotter = new Screenshotter();
        const steps = [
            {
                prepare: () => {
                    screenshotter.beginShooting();
                    APP.model.setFullCam(1.1, v3(-190, 0, 380));
                    //APP.model.rulers.visible = false;
                    APP.arrangement.object3d.ruler.visible = false;
                    APP.model.showDoorsClosed(true, 0);
                },
                name: 'screenshot.jpg',
                restore: () => {
                }
            },
            {
                prepare: () => {
                    APP.model.setFullCam(1.1);
                    APP.model.showDoorsClosed(false, 0);
                },
                name: 'screenshot2.jpg',
                restore: () => {
                }
            }
        ];

        APP.arrangement.schraenke.forEach((s, i) => {
            steps.push({
                prepare: () => {
                    APP.model.showDoorsClosed(true, 0);
                    sketcher = new Sketcher(data, s);
                    sketcher.createSketch();
                    STAGE.setDirty();
                },
                name: i > 0 ? `sketch${i + 1}.jpg` : 'sketch.jpg',
                restore: () => {
                    sketcher.restore();
                }

            });
        });

        const upload = (filename, blob, then) => {
            APP.uploadImage(data.Code, filename, blob, then, () => {
            });
        };

        let current = 0;
        const shootOne = () => {
            if (current < steps.length) {
                steps[current].prepare();
                screenshotter.shoot((blob) => {
                    steps[current].restore();
                    upload(steps[current].name, blob, () => {
                        current++;
                        shootOne()
                    });
                }, steps[current].name);
            }
            else {
                screenshotter.endShooting();
                APP.arrangement.object3d.ruler.visible = true;
                callback();
            }
        }
        shootOne();

    }


    static maybeFotorealisticRender() {
        if (APP.settings.fotorealisticRender) {
            const newCam = {
                fov: 45,
                near: 1,
                far: 2000,
                position: STAGE.camera.position,
                rotation: STAGE.camera.rotation
            }
            // STAGE.scene.add(newCam0);
            const cameras = [newCam];

            return APP.fotorealisticRender({
                cameras: cameras, projectName: "ocschrank", part: 1, multipart: 1, filename: "render.glb", render: true, object3d: APP.arrangement.object3d, before: () => {
                    APP.arrangement.object3d.scale.multiplyScalar(0.01);
                    // hm, nicht gebraucht hier?
                    /* APP.arrangement.object3d.traverse(o3 => {
                        if (o3.geometry && o3.geometry instanceof THREE.BufferGeometry && !o3.geometry.index) {
                            o3.geometry = o3.geometry.toIndexed();
                        }
                    }) */
                },
                code: data.Code, instancesToBeHidden: [InterieurDragBox, Fach]
            }).then(()=>{
                APP.model.scale.multiplyScalar(100);
                STAGE.renderSceneOnce();
            });
        } else {
            return APP.wkfgBackendApi.sendKonfigurationMail();
        }
    }

    static save() {
        this.blur = STAGE.freezeRendererAndBlur();

        // TODO das hier ist komisch. _saveAction sollte ein Promise zurückgeben...

        uiActions._saveAction(
            (link, data) => {
                const pdfUrl = APP.getPdfUrl(data);

                uiActions.maybeFotorealisticRender().then(()=>{

                    this.blur.hideDialog();

                    APP.uiHandler.dialog({
                        title: I18N('saveSuccess'),
                        text: I18N('saveSuccessText', link, link, pdfUrl),
                        buttons: [{ style: 'primary', label: I18N('OK'), onClick: ()=>{
                                let url = APP.settings.redirectAfterSave;
                                if (!Commons.isEmpty(url)) {
                                    url = url.replace('{Code}',APP.configuration.Code);
                                    location.href = url;
                                }
                            }}]
                    });
                }).catch((e)=>{
                    console.error(e);
                    this.blur.hideDialog();
                    APP.uiHandler.dialog({
                        title: I18N('saveFailed'),//'Speichern ist fehlgeschlagen!',
                        text: I18N('saveFailedText'),//'Wir konnten Ihren Schrank nicht speichern.',
                        buttons: [{ style: 'primary', label: I18N('OK') }]
                    });
                });

            },
            () => {
                APP.uiHandler.dialog({
                    title: I18N('saveFailed'),//'Speichern ist fehlgeschlagen!',
                    text: I18N('saveFailedText'),//'Wir konnten Ihren Schrank nicht speichern.',
                    buttons: [{ style: 'primary', label: I18N('OK') }]
                });
            }
        );
    }

    static pdf() {
        uiActions._saveAction(
            (link, config) => {
                const pdfUrl = APP.getPdfUrl(config);
                APP.uiHandler.dialog({
                    title: I18N('Pdf erstellt'),
                    text: I18N('Sie können das PDF über folgenden Link öffnen: <br/><br/> <a',pdfUrl ,pdfUrl,config.Code),
                    buttons: [{ style: 'primary', label: I18N('OK') }]
                });
            },
            () => {
                APP.uiHandler.dialog({
                    title: I18N('saveFailed'),//'Speichern ist fehlgeschlagen!',
                    text: I18N('saveFailedText'),//'Wir konnten Ihren Schrank nicht speichern.',
                    buttons: [{ style: 'primary', label: I18N('OK') }]
                });
            }
        );
    }

}